import { render, staticRenderFns } from "./RoleListForm.vue?vue&type=template&id=2a07a279&scoped=true"
import script from "./RoleListForm.vue?vue&type=script&lang=js"
export * from "./RoleListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a07a279",
  null
  
)

export default component.exports